module.exports = __webpack_public_path__ + "img/forward.4d6166a2.svg";